var resources = require('itemsViewStrings');
    var strings = resources['_1YPiqNSTrP1HGZEMzwUViQ'];
export { strings };
export default strings;
